import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardDetailsComponent } from './card-details.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadFormModule } from '../upload-form/upload-form.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MultiCheckInputModule } from '../multi-check-input/multi-check-input.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LinkInputModule } from '../link-input/link-input.module';
import { DirectivesModule } from 'src/app/directives/directives.modules';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HtmlEditorModule } from '../html-editor/html-editor.module';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { CustomDropdownComponent } from '../custom-dropdown/custom-dropdown.component';
import { TagManagerComponent } from '../tag-manager/tag-manager.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommentsModule } from '../comments/comments.module';

@NgModule({
  declarations: [CardDetailsComponent],
  imports: [
    CommonModule,
    MatInputModule,
    LoadingButtonComponent,
    MatSelectModule,
    DirectivesModule,
    MatButtonModule,
    ReactiveFormsModule,
    UploadFormModule,
    MatDialogModule,
    MatChipsModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatIconModule,
    MultiCheckInputModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    LinkInputModule,
    HtmlEditorModule,
    FormsModule,
    MatSlideToggleModule,
    MatExpansionModule,
    AttachmentsComponent,
    CustomDropdownComponent,
    TagManagerComponent,
    CommentsModule
  ],
  exports: [CardDetailsComponent],
})
export class CardDetailsModule {}
